import Icon from '../components/Icon.vue'

Icon.register({
  'luggage-cart': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M224 320H256V96H224C206.3 96 192 110.3 192 128V288C192 305.7 206.3 320 224 320zM576 288V128C576 110.3 561.7 96 544 96H512V320H544C561.7 320 576 305.7 576 288zM624 384H128V16C128 7.2 120.8 0 112 0H16C7.2 0 0 7.2 0 16V48C0 56.8 7.2 64 16 64H64V432C64 440.8 71.2 448 80 448H162.9C161.2 453 160 458.4 160 464 160 490.5 181.5 512 208 512S256 490.5 256 464C256 458.4 254.8 453 253.1 448H450.9C449.1 453 448 458.4 448 464 448 490.5 469.5 512 496 512S544 490.5 544 464C544 458.4 542.9 453 541.1 448H624C632.8 448 640 440.8 640 432V400C640 391.2 632.8 384 624 384zM480 96V48C480 21.5 458.5 0 432 0H336C309.5 0 288 21.5 288 48V320H480V96zM432 96H336V48H432V96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/luggage-cart.js
// module id = oaP8
// module chunks = 144